// Support plain API messages, Error instances, and Axios error responses.
export function getAlertMessage(value, fallback) {
    const candidates = [value, value?.response?.data?.message, value?.data?.message, value?.message];
    for (const candidate of candidates) {
        if (typeof candidate === 'string' && candidate.trim()) {
            return candidate.trim();
        }
    }
    return fallback;
}
